<ng-container *ngIf="cardholder as c">
	<a
		[attr.href]="c.canonicalURL || null"
		[attr.target]="c.canonicalURL ? '_blank' : null"
		[attr.rel]="c.canonicalURL ? 'noopener noreferrer' : null"
		[class.cursor-pointer]="c.canonicalURL"
		[attr.aria-disabled]="!c.canonicalURL"
		[attr.tabindex]="c.canonicalURL ? 0 : -1"
		class="d-inline-flex"
	>
		<div class="d-flex img-profile">
			<div class="picture" *ngIf="c.pictureUrl">
				<div [style.background-image]="'url(\'' + c.pictureUrl + '\')'" class="picture-image"></div>
			</div>
			<div class="picture d-flex justify-content-center align-items-center" *ngIf="!c.pictureUrl">
				<span class="d-flex align-items-center flex-column text-uppercase">
					<i class="fal fa-image"></i>
					{{ 'noImage' | translate }}
				</span>
			</div>
		</div>
		<div class="ml-3 content-name-type">
			<h4>{{ c.name || '--' }}</h4>
			<div class="d-inline-flex" *ngIf="c.client?.name || c.group?.name">
				<div class="info" *ngIf="c.client?.name"><i class="far fa-th-list"></i>{{ c.client?.name }}</div>
				<div class="info" *ngIf="c.group?.name"><i class="far fa-layer-group"></i>{{ c.group?.name }}</div>
			</div>
		</div>
	</a>
</ng-container>
